import { atom } from 'recoil'

export const guaranteesState = atom({
    key: 'guaranteesState',
    default: []
})

export const depositsState = atom({
    key: 'depositsState',
    default: []
})

export const transfersState = atom({
    key: 'transfersState',
    default: []
})

export const requestsState = atom({
    key: 'requestsState',
    default: []
})

export const treasuryBillsState = atom({
    key: 'treasuryBillsState',
    default: { data: [], contract: {} }
})

export const documentsState = atom({
    key: 'documentsState',
    default: { data: [], contract: {} }
})

export const documentTransfersState = atom({
    key: 'documentTransfersState',
    default: []
})

export const restrictionsState = atom({
    key: 'restrictionsState',
    default: []
})

export const summaryState = atom({
    key: 'summaryState',
    default: {}
})